// src/services/profileService.jsx
import http from "./http";

export const getAdminDetails = async (id) => {
  const res = await http.post("getAdminDetails", { id });
  return res.data;
};

export const updateAdminProfile = async (formData) => {
  const res = await http.post("updateAdminProfile", formData);
  return res.data;
};